import * as React from "react"
import { RentalAdvertPricing } from '../../../../types/types'

type Props = {
  pricing: RentalAdvertPricing
  onSubmit: () => void
  disabled: boolean
}

export default (props: Props) => (
  props.pricing.bookingLink && !props.disabled ?
    <button onClick={() => props.onSubmit()} className="btn btn--primary btn--large btn--block">{props.pricing.bookLabel}</button>
    :
    <button className="rebook-now btn btn--primary btn--large btn--block disabled">{props.pricing.bookLabel}</button>
)



